var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.qoute)?_c('div',{staticClass:"o-quote",attrs:{"id":_vm.item.key}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 offset-md-1"},[_c('div',{staticClass:"px-md-8",domProps:{"innerHTML":_vm._s(_vm.item.qoute)}})])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }